import { Modal } from '@tryhackme/thm-ui-components';
import { useEffect, useRef, useState } from 'react';
import { ForceTheme } from 'src/common/components/force-theme';
import { ThemeColorMode } from 'src/common/enums';
import { useGetUserQuery, useTrackEventMutation } from 'src/common/slices';
import { useActiveCampaign } from 'src/features/campaigns/hooks/use-active-campaign';
import { useCampaignStorage } from 'src/features/campaigns/hooks/use-campaign-storage';
import { CertificationsFlashSaleBanner, withModalStyling } from '../banner';
import { StyledContainer } from './modal.styles';
const wasLastSeenBefore24hAgo = (lastSeen: number | undefined) => {
  const now = Date.now();
  const seen = new Date(lastSeen ?? 0).getTime();
  const hasElapsed24h = Math.abs(now - seen) > 24 * 60 * 60 * 1000;
  return hasElapsed24h;
};
const FlashSaleBanner = withModalStyling(CertificationsFlashSaleBanner);
export const CertificationsFlashSaleModal = () => {
  const [trackEvent] = useTrackEventMutation();
  const {
    campaign
  } = useActiveCampaign();
  const {
    data: userData
  } = useGetUserQuery();
  const {
    isSeen,
    lastSeen,
    markAsSeen
  } = useCampaignStorage(campaign);
  const [open, setOpen] = useState(Boolean(campaign) && (!isSeen || wasLastSeenBefore24hAgo(lastSeen)));
  const tracked = useRef(false);
  const occupation = userData?.data?.user?.demographics?.occupation;
  const isPremium = userData?.data?.user?.isPremium;
  useEffect(() => {
    if (isSeen && !wasLastSeenBefore24hAgo(lastSeen)) {
      setOpen(false);
    }
  }, [isSeen, lastSeen]);
  useEffect(() => {
    if (!tracked.current) {
      tracked.current = true;
      trackEvent({
        event: 'view-popup',
        properties: {
          name: 'flash-sale-modal'
        }
      });
    }
  }, [trackEvent]);
  const onOpenChange = (isOpen: boolean) => {
    if (isOpen) return;
    markAsSeen();
    setOpen(false);
  };
  if (!campaign) return null;
  return <ForceTheme themeMode={ThemeColorMode.DARK} data-sentry-element="ForceTheme" data-sentry-component="CertificationsFlashSaleModal" data-sentry-source-file="modal.tsx">
      <Modal maxWidth="80rem" padding="0" open={open} onOpenChange={onOpenChange} preventCloseOnOutsideClick data-sentry-element="Modal" data-sentry-source-file="modal.tsx">
        <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="modal.tsx">
          <FlashSaleBanner onClick={markAsSeen} occupation={occupation} isPremium={isPremium} data-sentry-element="FlashSaleBanner" data-sentry-source-file="modal.tsx" />
        </StyledContainer>
      </Modal>
    </ForceTheme>;
};